export interface IReportLineItem {
    LineItemId: number;
}

export interface IReport {
    ReportId: number;
    ReportType: ReportType;
    AddDate: Date;
    StartDate: Date;
    FinishDate: Date;
    RowCount: number;
    AddedBy: string;
    AddedByDisplayName: string;
    Exception: string;
    Status: ReportStatus;
    Description: string;
    RunDurationMs: number;
    HasBeenViewed: boolean;
}

export interface IReportHistory {
    ReportId: number;
    ReportType: ReportType;
    PermitIds: string[];
    Description: string;
    AddedBy: string;
    AddedByDisplayName: string;
    AddDate: Date;
    HasBeenViewed: boolean;
    RowCount: number;
    Status: ReportStatus;
    RunDurationMs: number;
}

export enum ReportType {
    Planting = 1,
    NotPlanted = 2,
    Volunteer = 3,
    FinalFieldTest = 4,
    RegulatedRegComp = 5,
    StewardedRegComp = 6
}

export enum RegulatedRegCompReportType {
    InformationDatesReport = 1,
    PlantHarvestReport = 2,
    FieldMonitoringReport = 3,
    FinalDispositionReport = 4,
    PostTrialReport = 5
}

export enum ReportStatus {
    Waiting = 1,
    Running = 2,
    Exception = 3,
    Finished = 4,
    Unknown = 5
}

export interface IOldNewId {
    OldId: number;
    NewId: number;
}
